"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithdrawalManual = void 0;
var Withdrawal_1 = require("./Withdrawal");
Object.defineProperty(exports, "WithdrawalManual", { enumerable: true, get: function () { return __importDefault(Withdrawal_1).default; } });
